module.exports = __webpack_public_path__ + "b38f7389f82670fd8c1fc2c26a86fd41.svg";